// import api from '@/api/system';
import * as types from '@/store/mutations_type';

const calculatePrivProducts = (allProducts, privProductIDs) => {
  if (!allProducts.length || !privProductIDs.length) {
    return [];
  }
  return allProducts.filter(product => privProductIDs.indexOf(product.id) !== -1);
};

export default {
  updateAllProducts({ commit, state }, list) {
    commit(types.SET_ALL_PRODUCTS, list);
    commit(types.SET_PRIV_PRODUCTS, calculatePrivProducts(list, state.privProductIDs));
  },
  updatePriviProductIDs({ commit, state }, ids) {
    commit(types.SET_PRIV_PRODUCT_IDS, ids);
    commit(types.SET_PRIV_PRODUCTS, calculatePrivProducts(state.allProducts, ids));
  },
};



// WEBPACK FOOTER //
// ./src/store/action.js